module.exports = __webpack_public_path__ + "static/media/sunish.6a27cbdc.png";